/**
 * Checks for a numeric match within a certain tolerance.
 *
 * @param {number} value1
 * @param {number} value2
 * @param {number} tolerance
 */
export function checkMatch(value1, value2, tolerance) {
    return value1 - tolerance <= value2 && value2 <= value1 + tolerance;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hlY2tNYXRjaC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsaXRpZXMvZ2VuZXJhbC9jaGVja01hdGNoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7R0FNRztBQUNILE1BQU0sVUFBVSxVQUFVLENBQ3hCLE1BQWMsRUFDZCxNQUFjLEVBQ2QsU0FBaUI7SUFFakIsT0FBTyxNQUFNLEdBQUcsU0FBUyxJQUFJLE1BQU0sSUFBSSxNQUFNLElBQUksTUFBTSxHQUFHLFNBQVMsQ0FBQztBQUN0RSxDQUFDIn0=